import { render, staticRenderFns } from "./WQuestionEditor.vue?vue&type=template&id=497b02d2&"
import script from "./WQuestionEditor.vue?vue&type=script&lang=ts&"
export * from "./WQuestionEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports